/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChangeEntryKind = {
    Created: 'Created',
    Modified: 'Modified',
    Added: 'Added',
    Removed: 'Removed'
} as const;
export type ChangeEntryKind = typeof ChangeEntryKind[keyof typeof ChangeEntryKind];


export function instanceOfChangeEntryKind(value: any): boolean {
    for (const key in ChangeEntryKind) {
        if (Object.prototype.hasOwnProperty.call(ChangeEntryKind, key)) {
            if (ChangeEntryKind[key as keyof typeof ChangeEntryKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChangeEntryKindFromJSON(json: any): ChangeEntryKind {
    return ChangeEntryKindFromJSONTyped(json, false);
}

export function ChangeEntryKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeEntryKind {
    return json as ChangeEntryKind;
}

export function ChangeEntryKindToJSON(value?: ChangeEntryKind | null): any {
    return value as any;
}

export function ChangeEntryKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ChangeEntryKind {
    return value as ChangeEntryKind;
}

